import React, { useState, useEffect, useContext } from "react";
import { FaTimes } from "react-icons/fa";
import useEscClose from "../../hooks/useEscClose";
import { addToCartAndOrderExpress } from "../../utils/addToCartAndOrderExpress";
import { CartContext } from "../../context/CartContext";

export default function ProductInfoModal({ open, onClose, product, onQtyChange, user }) {
    const { addToCart } = useContext(CartContext);
    const [qty, setQty] = useState(1);
    const [inputVal, setInputVal] = useState("1");
    const [subtotal, setSubtotal] = useState(0);
    const [tax, setTax] = useState(0);
    const [isProformaMode, setIsProformaMode] = useState(
        () => localStorage.getItem("order_mode") === "proforma"
    );

    useEffect(() => {
        const sync = () => setIsProformaMode(localStorage.getItem("order_mode") === "proforma");
        window.addEventListener("orderModeChange", sync);
        return () => window.removeEventListener("orderModeChange", sync);
    }, []);

    const porcentaje = Number(user?.porcentaje || 0) / 100;

    useEffect(() => {
        if (product) {
            const n = product.qty || 1;
            setQty(n);
            setInputVal(String(n));
            const subtotalCents = Math.round(Math.round(product.price * 10000) * (product.qty || 1) / 100);
            const subtotalStr = (subtotalCents / 100).toFixed(2);
            setSubtotal(subtotalStr);

            const taxValue = product.payTax
                ? (Math.round((subtotalCents * porcentaje) + Number.EPSILON) / 100).toFixed(2)
                : "0.00";
            setTax(taxValue);
        }
    }, [product]);

    useEffect(() => {
        if (!isNaN(qty) && product) {
            const subtotalCents = Math.round(Math.round(product.price * 10000) * qty / 100);
            const subtotalStr = (subtotalCents / 100).toFixed(2);
            setSubtotal(subtotalStr);

            const taxValue = product.payTax
                ? (Math.round((subtotalCents * porcentaje) + Number.EPSILON) / 100).toFixed(2)
                : "0.00";
            setTax(taxValue);
        }
    }, [qty]);

    useEscClose(open, onClose);

    const handleAccept = () => {
        if (user.idCustomer === null) {
            alert("Debe seleccionar un cliente!");
            return;
        }
        const productForCart = {
            idProduct: product.idProduct,
            productId: product.productId,
            productName: product.productName,
            unitPrice: product.unitPrice,
            payTax: product.payTax,
            service: product.service,
            acuerdo: product.acuerdo,
            categoryId: product.categoryId,
        };

        addToCartAndOrderExpress({
            product: productForCart,
            qty: qty,
            user: user,
            addToCart: addToCart,
        });

        if (onQtyChange) {
            onQtyChange(qty, subtotal, tax);
        }
        onClose();
    };

    if (!open || !product) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[99999]">
            <div className="bg-white w-[750px] rounded-2xl shadow-xl overflow-hidden animate-fade-in">

                {/* HEADER */}
                <div className="flex justify-between items-center px-5 py-3 border-b bg-gray-50">
                    <h2 className="text-xl font-bold">Información del Producto</h2>
                    <button onClick={onClose} className="text-gray-600 hover:text-black">
                        <FaTimes size={22} />
                    </button>
                </div>

                {/* CONTENIDO */}
                <div className="p-6 grid grid-cols-2 gap-6">

                    {/* IMAGEN GRANDE IZQUIERDA */}
                    <div className="relative">
                        {/* ETIQUETA IVA - pill (solo se marca la excepcion: productos exentos) */}
                        {user && !product.payTax && (
                            <div className="absolute top-0 right-0 bg-amber-500 text-white text-[11px] font-bold px-2 py-1 rounded-md shadow-sm z-10 whitespace-nowrap">
                                Exento de IVA
                            </div>
                        )}
                        <img
                            src={product.img}
                            className="w-full h-72 object-contain rounded-xl border shadow"
                        />
                    </div>

                    {/* INFORMACIÓN A LA DERECHA */}
                    <div className="flex flex-col justify-between">

                        <div>
                            <p
                                className="text-xl font-bold text-gray-900 leading-tight mb-2 px-1 rounded"
                                style={product.notes && product.notes !== (product.productName || product.description) ? { backgroundColor: '#00D2D2' } : {}}
                            >
                                {product.notes || product.productName || product.description}
                            </p>

                            <p className="text-gray-600 text-sm mb-3">
                                Código: <span className="font-bold">{product.productId || product.code}</span>
                            </p>

                            <p className="text-3xl font-extrabold text-brand-primary mb-4">
                                $ {Number(product.price || 0).toFixed(4)}
                            </p>

                            {/* MODIFICAR CANTIDAD */}
                            <div className="mb-5">
                                <label className="block text-gray-700 font-medium mb-1">
                                    Cantidad
                                </label>
                                <input
                                    type="number"
                                    min={1}
                                    value={inputVal}
                                    onChange={(e) => setInputVal(e.target.value)}
                                    onBlur={(e) => {
                                        const n = Math.max(1, Number(e.target.value) || 1);
                                        setQty(n);
                                        setInputVal(String(n));
                                    }}
                                    onFocus={(e) => e.target.select()}
                                    className="w-28 border rounded-lg px-3 py-2 text-center text-lg shadow-sm"
                                />
                            </div>

                            {/* SUBTOTAL */}
                            <p className="text-lg font-bold text-gray-800">
                                Subtotal: <span className="text-brand-primary text-3xl">$ {subtotal}</span>
                            </p>
                        </div>

                        {/* BOTÓN GUARDAR CAMBIOS */}
                        <button
                            onClick={handleAccept}
                            className={`w-full py-3 rounded-lg text-lg font-semibold hover:brightness-90 transition mt-6 text-black ${isProformaMode ? "bg-[#FFFFB3]" : "bg-[#80FF80]"}`}
                        >
                            {isProformaMode ? "Agregar a Solicitud de Proforma" : "Agregar a Orden"}
                        </button>

                    </div>

                </div>

            </div>
        </div>
    );
}